function Footer() {
    return (
        <div className="bg-primary p-12">
            <div className="grid grid-cols-1">
                <div className="text-center text-white font-bold text-5xl">Contact</div>
                <div className="text-center text-white mt-10">
                    <div><span className="font-bold">Phone:</span> xxx-xxxx-xxxx</div>
                    <div><span className="font-bold">Fax:</span> xxx-xxxx-xxxx</div>
                    <div><span className="font-bold">Email:</span> office@jaagegeenkanko.com</div>
                    <div><span className="font-bold">Address:</span> xxx</div>
                </div>
            </div>
        </div>
    )
}

export default Footer;